import { PaymentDetails, PaymentStatus, RefType } from './models';

const createQueryString = (jsonObject: { [key: string]: string | number }) => {
  let queryString = '';
  Object.keys(jsonObject).forEach((key: string, index: number) => {
    const value = jsonObject[key];
    if (value !== undefined) {
      queryString += `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value)}`;
    }
  });

  return queryString;
};

export const redirectOnCancelPayment = (
  data: PaymentDetails,
  refType: string,
  closeModal: boolean,
  redirectUrl?: string,
) => {
  if (data?.status === PaymentStatus.CapturedFailed && !closeModal) {
    window.location.href = !redirectUrl
      ? refType === RefType.Subscription
        ? `${window.location.origin}/subscription-confirmation/${data.refId}`
        : `${window.location.origin}/order/${data.refId}`
      : redirectUrl;
  }
};

export default createQueryString;
